export function mountComponent(component, root) {
    root.innerHTML = component.template;

    if (component.onMount) {
        component.onMount();
    }

    return () => {
        if (component.onUnmount) component.onUnmount();
        root.innerHTML = "";
    };
}
